// extracted by mini-css-extract-plugin
export default {"renameModal":"styles_renameModal__BeoCQ","header":"styles_header__x7kyl","title":"styles_title__e-bYd","inputField":"styles_inputField__v2r7m","input":"styles_input__3323r"};